module.exports = __webpack_public_path__ + "static/img/5785.4e5334fc.png";